"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadChannels = exports.FetchChannels = exports.FetchChannelsActionTypes = exports.ChannelActionTypes = void 0;

var _actions = require("settings-ui-sdk/utils/actions");

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var ChannelActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_CHANNELS: null,
  FETCH_CHANNELS: null
}, 'shared');
exports.ChannelActionTypes = ChannelActionTypes;
var FetchChannelsActionTypes = (0, _actions.createRequestTypes)(ChannelActionTypes.FETCH_CHANNELS);
exports.FetchChannelsActionTypes = FetchChannelsActionTypes;
var FetchChannels = (0, _actions.createRequestActions)(FetchChannelsActionTypes);
exports.FetchChannels = FetchChannels;
var loadChannels = (0, _fluxActions.createAction)(ChannelActionTypes.LOAD_CHANNELS);
exports.loadChannels = loadChannels;